"use client";
import { styled } from "@mui/material/styles";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const BREAKPOINT_STYLES = {
  md: {
    flexDirection: "column",
    justifyContent: "center"
  }
};
const getBreakpointStyles = (size, theme) => ({
  [theme.breakpoints.down("md")]: BREAKPOINT_STYLES.md,
  [theme.breakpoints.between("md", "lg")]: {
    flexDirection: size === "full" ? "column" : "row"
  },
  [theme.breakpoints.up("lg")]: {
    flexDirection: size === "full" ? "column" : "row",
    justifyContent: size === "full" ? "center" : "flex-start"
  }
});
const MainContainer = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "size"
})(({ size, theme }) => ({
  display: "flex",
  flexWrap: size === "full" ? "nowrap" : "wrap",
  gap: SpaceLg,
  justifyContent: "flex-start",
  width: "100%",
  ...getBreakpointStyles(size, theme)
}));
export {
  MainContainer
};
